import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../config/api';

const RequestGraderRole = () => {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (reason.trim().length < 10) {
      setError('Please provide at least 10 characters explaining why you want to become a grader.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await axios.post(`${API_BASE_URL}/api/users/request-grader`, { reason });
      setSuccess(response.data.message);
      setReason('');
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to submit request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h1>Request Grader Role</h1>
          <Link to="/" className="btn btn-secondary">
            Back to Dashboard
          </Link>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <h3>Why Become a Grader?</h3>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.6', color: '#666' }}>
            <li>Help fellow students by providing feedback on their mathematical solutions</li>
            <li>Gain deeper understanding of problem-solving techniques</li>
            <li>Develop skills in mathematical communication and evaluation</li>
            <li>Contribute to the IMO Sprint Program community</li>
          </ul>
        </div>

        <div style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#e7f3ff', borderRadius: '8px', border: '1px solid #b3d9ff' }}>
          <h4 style={{ margin: '0 0 8px 0', color: '#0066cc' }}>Grader Responsibilities:</h4>
          <ul style={{ paddingLeft: '20px', margin: 0, color: '#0066cc' }}>
            <li>Provide constructive feedback on student solutions</li>
            <li>Score submissions fairly and consistently</li>
            <li>Follow grading guidelines and rubrics</li>
            <li>Maintain professionalism in all feedback</li>
          </ul>
        </div>

        {error && (
          <div className="alert alert-error" style={{ marginBottom: '20px' }}>
            {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success" style={{ marginBottom: '20px' }}>
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">
              Why do you want to become a grader? *
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="form-control"
              rows="6"
              placeholder="Please explain your motivation, qualifications, and commitment to becoming a grader. This should include your mathematical background, experience with IMO-style problems, and how you plan to contribute to student learning. (Minimum 10 characters)"
              required
            />
            <div className="text-muted" style={{ fontSize: '14px', marginTop: '4px' }}>
              Characters: {reason.length} (minimum 10 required)
            </div>
          </div>

          <div style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffeaa7' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#856404' }}>Please Note:</h4>
            <ul style={{ paddingLeft: '20px', margin: 0, color: '#856404' }}>
              <li>Your request will be reviewed by an administrator</li>
              <li>You will be notified via email when your request is processed</li>
              <li>Approval is not guaranteed and depends on program needs</li>
              <li>You can only submit one request at a time</li>
            </ul>
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              type="submit"
              className="btn btn-success"
              disabled={loading || reason.trim().length < 10}
              style={{ flex: 1 }}
            >
              {loading ? (
                <span>
                  <div className="spinner" style={{ 
                    width: '16px', 
                    height: '16px', 
                    display: 'inline-block', 
                    marginRight: '8px' 
                  }}></div>
                  Submitting Request...
                </span>
              ) : (
                'Submit Grader Request'
              )}
            </button>
            
            <Link to="/" className="btn btn-secondary" style={{ flex: 1 }}>
              Cancel
            </Link>
          </div>
        </form>
      </div>

      <div className="card">
        <h3>Frequently Asked Questions</h3>
        
        <div style={{ marginBottom: '16px' }}>
          <h4 style={{ color: '#333', marginBottom: '8px' }}>Who can become a grader?</h4>
          <p style={{ color: '#666', margin: 0 }}>
            Students with strong mathematical backgrounds, experience with competition problems, 
            and a commitment to helping others learn.
          </p>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <h4 style={{ color: '#333', marginBottom: '8px' }}>How long does the approval process take?</h4>
          <p style={{ color: '#666', margin: 0 }}>
            Typically 1-3 business days. You'll receive an email notification with the decision.
          </p>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <h4 style={{ color: '#333', marginBottom: '8px' }}>What if my request is rejected?</h4>
          <p style={{ color: '#666', margin: 0 }}>
            You can reapply after improving your qualifications or when program needs change. 
            Rejection doesn't affect your student status.
          </p>
        </div>

        <div>
          <h4 style={{ color: '#333', marginBottom: '8px' }}>Can graders still submit solutions as students?</h4>
          <p style={{ color: '#666', margin: 0 }}>
            No, graders focus on evaluation and feedback. If you want to solve problems, 
            you would need to switch back to student role.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RequestGraderRole;
